import React from 'react';

import { Epg } from 'common/constants/data-types';
import MetadataSeparator from './MetadataSeparator';
import './MetadataStrip.styles';

interface MetadataCategoryProps {
  major_category?: Epg['major_category'];
  minor_categories?: Epg['minor_categories'];
}

function MetadataCategory({ minor_categories, major_category }: MetadataCategoryProps) {
  const renderCategories = () => {
    if (!minor_categories) {
      return null;
    }

    return (
      <span className="metadata-minor-categories" data-test-id="metadata-minor-categories">
        {minor_categories.map(
          (category, index) => `${category}${index !== minor_categories.length - 1 ? ', ' : ''}`
        )}
      </span>
    );
  };

  return (
    <>
      <MetadataSeparator />
      <span className="metadata-major-category" data-test-id="metadata-major-category">
        {major_category}
      </span>
      {minor_categories?.length && <MetadataSeparator separator={'/'} />}
      {renderCategories()}
    </>
  );
}

export default React.memo(MetadataCategory);
